import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import SectionContainer from '../Container';
import CtaTextLink from '../CtaTextLink';

export const Section = styled.section`
  display: flex;
  flex-direction: unset;
  align-items: center;
  max-width: 100%;
  width: 100%;
  position: relative;
  padding: 2.5rem 0 5rem;
  background-color: ${(props) => themeGet(`colors.${props.bg}`)};
  color: ${(props) => themeGet(`colors.${props.color}`)};

  ${({ themes, bg }) =>
    themes === 'dark' &&
    (bg === 'white' || bg === 'transparent' || bg === 'null') &&
    css`
      background-color: transparent;
    `};

  ${({ themes, color }) =>
    themes === 'dark' &&
    (color === 'black' || color === 'null') &&
    css`
      color: ${themeGet('colors.body-copy')};
    `};

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding: 1.875rem 0 3.75rem;
  }
`;

export const Container = styled(SectionContainer)`
  text-align: center;
  align-items: center;
  display: flex;
  align-items: center;
  flex-direction: column;

  width: 100%;
  max-width: 60rem;

  @media (max-width: ${themeGet('breakpoints.lg')}) {
    max-width: 100%;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  width: 100%;
  position: relative;
  margin: 0 auto;
  padding-bottom: 2.5rem;

  @media (max-width: ${themeGet('breakpoints.md')}) {
    padding-bottom: 1.25rem;
  }

  ${({ faqItems }) =>
    !faqItems &&
    css`
      padding-bottom: 0;
    `};

  h2 {
    width: 80%;
    margin-bottom: 0;

    @media (max-width: ${themeGet('breakpoints.lg')}) {
      width: 100%;
    }
  }
`;

export const Faq = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  a {
    color: ${themeGet('colors.body-copy')};

    &:hover {
      color: ${themeGet('colors.body-copy')};
    }
  }
`;

export const FaqItem = styled(CtaTextLink)`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin: 0 auto;
  border: none;
  cursor: pointer;
  padding: 0.625rem 2rem 0.625rem 0.625rem;
  border-bottom: 1px solid ${themeGet('colors.divider-grey-light')};
  text-decoration: none;
  transition: all 0.2s ease 0s;

  &[aria-selected='true'] {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
    z-index: 1;
    height: 66px;
    margin-top: 10px;
    font-weight: 600;
  }

  &.hide {
    display: none;
  }

  &:hover,
  &:focus {
    opacity: 0.6;
    transition: all 0.2s ease 0s;
  }

  &:focus {
    outline-color: ${themeGet('colors.body-copy')};
  }

  &:after {
    content: '';
    display: inline-block;
    border-right: 2px solid ${themeGet('colors.body-copy')};
    border-bottom: 2px solid ${themeGet('colors.body-copy')};
    width: 14px;
    height: 14px;
    transform: rotate(-45deg);
    position: absolute;
    top: 38%;
    right: 0.625rem;
    transition: all 0.2s ease 0s;
  }

  &:hover {
    &:after {
      right: 0;
      transition: all 0.2s ease 0s;
    }
  }

  p {
    font-size: 1.125rem;
    line-height: 1.67;
    font-weight: ${themeGet('fontWeights.normal')};
    margin: 0;
    text-align: left;

    @media (max-width: ${themeGet('breakpoints.lg')}) {
      font-size: 1rem;
    }

    strong {
      font-weight: ${themeGet('fontWeights.normal')};
    }
  }
`;
